import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/last-index-of";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { every, isEmpty, omit } from "lodash";
import DuplicatorMixin from "../../../shared/utils/application-mixins/duplicator-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GroupSet",
  mixins: [DuplicatorMixin],
  props: {
    groupName: {
      type: String,
      default: ""
    },
    multi: Boolean,
    showAdditionsAmount: {
      type: Boolean,
      default: false
    },
    source: {
      type: [Array, Object],
      default: () => []
    },
    generateSkeleton: {
      type: Boolean,
      default: true
    },
    path: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    startEmpty: Boolean,
    className: {
      type: String,
      default: ""
    },
    addAsButton: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 100
    },
    hideAddButton: {
      type: Boolean,
      default: false
    },
    portal: {
      type: String,
      default: "client"
    },
    translationMap: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      flag: true,
      alreadyAdded: false,
      keysToDelete: ["replicated"],
      groupSetVisible: null,
      amountOfAdditions: 1,
      dropDownItemsSize: 10
    };
  },
  computed: {
    computedGroupName() {
      if (!this.translationMap) return this.groupName;
      return this.$options.filters.getSchemaTranslation(this.groupName, this.translationMap);
    },
    groupClass() {
      return `${this.groupName}-group ${this.className}`;
    },
    emptySource() {
      return this.source.length === 0;
    },
    isExistingMortgages() {
      var _context, _context2;
      if (this.portal === "broker") return false;
      const lastPathIndicator = this.path.substr(_lastIndexOfInstanceProperty(_context = this.path).call(_context, "["), _lastIndexOfInstanceProperty(_context2 = this.path).call(_context2, "]"));
      return _includesInstanceProperty(lastPathIndicator).call(lastPathIndicator, "other-property-existing-mortgages");
    },
    isOtherProperties() {
      var _context3, _context4;
      // TODO Improve isEmpty check with every to avoid hardcoding group name which will potentially break if schema changes its name.
      // using path is safer than groupName to hard check this
      const lastPathIndicator = this.path.substr(_lastIndexOfInstanceProperty(_context3 = this.path).call(_context3, "["), _lastIndexOfInstanceProperty(_context4 = this.path).call(_context4, "]"));
      return _includesInstanceProperty(lastPathIndicator).call(lastPathIndicator, "other-properties");
    },
    emptyCondition() {
      if (!this.source) return;
      const onlyOneAndEmpty = this.isOtherProperties || every(this.source[0], isEmpty) && this.source.length === 1;
      return onlyOneAndEmpty && this.startEmpty;
    },
    addTitle() {
      return this.emptyCondition ? "" : this.$t("global.words.another").toLowerCase();
    },
    pluralizeGroupName() {
      return pluralize(this.computedGroupName).toLowerCase();
    },
    singularizeGroupName() {
      var _context5;
      const groupNameText = _includesInstanceProperty(_context5 = this.groupName.toLowerCase()).call(_context5, "details") ? this.computedGroupName : pluralize(this.computedGroupName, 1);
      return groupNameText.toLowerCase();
    },
    limitReached() {
      return this.source.length === this.limit;
    },
    addButtonShowCondition() {
      if (this.hideAddButton) return false;
      return !this.limitReached;
    },
    firstOneVisible() {
      var _this$source$;
      if (!this.startEmpty) return true;
      const sourceGroupSet = (_this$source$ = this.source[0]) == null ? void 0 : _this$source$.groupSetVisible;
      return sourceGroupSet == null ? this.groupSetVisible : sourceGroupSet;
    },
    otherPropertiesEmpty() {
      const firstProperty = this.source[0] || {};
      const emptyDetails = every(omit(firstProperty["property-details"], "address"), isEmpty) && every(firstProperty["property-details"]["address"], isEmpty);
      const emptyCosts = every(firstProperty["property-costs"], isEmpty);
      const emptyRental = every(firstProperty["property-rental"], isEmpty);
      const firstPropertyEmpty = emptyDetails && emptyCosts && emptyRental;
      return this.source.length === 1 && firstPropertyEmpty;
    },
    showContent() {
      return this.firstOneVisible || !this.emptyCondition || this.isExistingMortgages;
    }
  },
  mounted() {
    this.groupSetVisible = this.isOtherProperties ? !this.otherPropertiesEmpty : !every(this.source[0], isEmpty);
  },
  methods: {
    add() {
      const source = this.generateSkeleton ? this.getStructure(this.source[0]) : this.source[0];
      this.keysToDelete.forEach(key => {
        if (source[key]) delete source[key];
      });
      const what = this.generateSkeleton ? this.getStructure(source) : source;
      this.$emit("duplicate", {
        what,
        where: this.path,
        startEmpty: this.startEmpty,
        markAsVisible: !this.firstOneVisible,
        amountItems: this.amountOfAdditions
      });
      this.alreadyAdded = true;
      this.$nextTick(() => {
        this.amountOfAdditions = 1;
      });
    }
  }
});